import React from 'react';
import Grid from '@mui/material/Grid2';

import { PairedNumberEnhancement, UpgradableNumber } from "@dndModels";
import { AbilityScoreType, SpellLevel } from '@dndModels/Types';

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  name: string;
  value: PairedNumberEnhancement;
  use_creature: boolean;
  slot_level?: SpellLevel;
  quick_options?: AbilityScoreType[];
  disabled: boolean;
  onChange: () => void;
}

/**
 * Covers the PairedUGN-based fields: temp_hit_points, and each ability score
 * inside TransformStatsEnhancement (via TransformStatsEnhancementInput).
 */
export default function PairedNumberEnhancementInput({
  name,
  value,
  use_creature,
  slot_level,
  quick_options,
  disabled,
  onChange
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">{ name }</Grid>
      <Grid size={4}>
        <EnhancementModeBox
          modes={["Leave","Replace","Replace if Greater","Add"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as PairedNumberEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={4}>
        <UpgradableNumberBox
          name="From Target"
          slot_level={slot_level}
          quick_options={quick_options}
          value={value.value.from_target}
          disabled={disabled || value.mode === "Leave"}
          onChange={(changed: UpgradableNumber) => {
            value.value.from_target = changed.clone();
            onChange();
          }}
        />
      </Grid>
      <Grid size={4}>
        { use_creature && 
          <UpgradableNumberBox
            name="From Creature"
            slot_level={slot_level}
            quick_options={quick_options}
            value={value.value.from_creature}
            disabled={disabled || value.mode === "Leave"}
            onChange={(changed: UpgradableNumber) => {
              value.value.from_creature = changed.clone();
              onChange();
            }}
          />
        }
      </Grid>
    </Grid>
  );
}
